import Css from "./style.module.scss";

import fallbackLogo from "assets/business.svg";
import quickBooksAccountantLogo from "assets/quickBooksAccountant.svg";

import { TableCell } from "nlib/ui/Table";
import { getProjectName } from "selectors/organizations";
import { useDispatch, useSelector } from "react-redux";
import AutoTooltip from "nlib/ui/AutoTooltip";
import BusinessStatus from "nlib/common/BusinessStatus";
import Businesses from "utils/Businesses";
import IntegrationServices from "const/IntegrationServices";
import IntegrationsActions from "actions/IntegrationsActions";
import React, { useCallback } from "react";

const NameCell = ({ className, name, businessId, extraData, settings }) => {
  const { integrationService } = extraData;

  const dispatch = useDispatch();

  const projectName = useSelector(getProjectName);

  const {
    logo: serviceLogo,
    label: serviceName
  } = IntegrationServices.getByValue(integrationService)
    || { logo: fallbackLogo, label: projectName };

  const quickBooksAccountantBusiness = !!extraData.quickBooksAccountantClients;

  const serviceTooltip = quickBooksAccountantBusiness
    ? IntegrationServices.QUICK_BOOKS.altLabel
    : serviceName;

  const handleReconnectClick = useCallback(async(event) => {
    event.preventDefault();
    event.stopPropagation();

    const quickBooksDesktopBusiness = extraData.integrationService === IntegrationServices.QUICK_BOOKS_DESKTOP.value;

    if (quickBooksDesktopBusiness) {
      window.location.href = `/${businessId}`;
    } else {
      const consentUrl = await dispatch(IntegrationsActions.buildConsentUrl(
        extraData.integrationService,
        { rpaMode: Businesses.checkIsRpaMode(extraData) }
      ));

      if (consentUrl) window.location.href = consentUrl;
    }
  }, [businessId, extraData, dispatch]);

  return (
    <TableCell className={`${Css.nameCell} ${className}`}>
      <a href={`/${businessId}`}>
        <div
          className={Css.logo}
          data-tooltip={serviceTooltip}
          data-tooltip-position="right">
          <img
            alt={serviceTooltip}
            src={quickBooksAccountantBusiness ? quickBooksAccountantLogo : serviceLogo} />
        </div>
        <div className={Css.content}>
          <AutoTooltip title={name}>
            <div className={Css.name}>{name}</div>
          </AutoTooltip>
          <BusinessStatus
            extraData={extraData}
            settings={settings}
            onReconnectClick={handleReconnectClick} />
        </div>
      </a>
    </TableCell>
  );
};

export default React.memo(NameCell);
